
import PerfectScrollbar from 'perfect-scrollbar';

export function searchAndLinkContact() {
  return {
    restrict: 'E',
    template: require('./search-and-link-contact.directive.html'),
    scope: {
      tab:' <',
      linkButtonClickedFn: '&linkButtonClicked'
    },
    controller: controller,
    link: link
  };
}

controller.$inject = ['$scope', 'CrmFactory', 'AlertingFactory', '$translate', 'CrmStrategiesFactory', '$mdDialog'];
function controller($scope, CrmFactory, AlertingFactory, $translate, CrmStrategiesFactory, $mdDialog) {

  $scope.searchContacts = searchContacts;

  init();

  function searchContacts(searchEntry, isDirect) {
    const org = $scope.tab.organization;

    let searchFnName;
    if (isDirect) {
      searchFnName = searchEntry.search_type === 'smart' ? 'directSmartSearchObject' 
                                                         : 'directExactSearchObject';
    } else {
      searchFnName = searchEntry.search_type === 'smart' ? 'indirectSmartSearchObject' 
                                                         : 'indirectExactSearchObject';
    }
    $scope.loading = true;
    $scope.crmFoundUsers = null;
    CrmFactory[searchFnName]($scope.tab.linkedDataContext.companyId, 
                          org.id, 
                          org.configuration.contact_object_name,
                          org.configuration.contact_search_form.result_list_columns,
                          searchEntry)
      .then(response => $scope.crmFoundUsers = response.data,
            response => CrmFactory.handleCrmErrors(response, 'crm/user-profile/search-failed'))
      .finally(() => $scope.loading = false);
  }

  function openContactCreationForm() {
    $mdDialog.show({
      controller: 'CreateCrmContactController',
      template: require('./create-crm-contact.html'),
      clickOutsideToClose: false,
      multiple: true,
      resolve: {},
      locals: {
        companyId: $scope.tab.linkedDataContext.companyId,
        organization: $scope.tab.organization,
        groupName: $scope.tab.linkedDataContext.groupName
      }
    })
    .then((createdCrmContact) => {
      $scope.linkButtonClickedFn({
        contactId: createdCrmContact
      })
    })
  }

  function init() {
    const org = $scope.tab.organization;
    const crmStrategy = CrmStrategiesFactory.getStrategy(org.type);
    $scope.openContactCreationForm = openContactCreationForm;

    // Launch default search
    let entry;
    if (crmStrategy.canChooseSearchType()){
        // As a convenience for the user, let's try a contact search based on name the user name we have in Alcmeon
        // We assume that first entry with search_group or field_name = name is the one with contact name
        entry = $scope.tab.organization.configuration.contact_search_form.direct_search_entries.find(entry => entry.search_group == 'NAME');
    }
    else{
        entry = $scope.tab.organization.configuration.contact_search_form.direct_search_entries.find(entry => entry.field_name == 'name');
    }

    if (entry) {
      entry.field_value = $scope.tab.linkedDataContext.groupName;
      searchContacts(entry, true);
    }

    // Construct translated string from templates (insert the crm name inside the template)
    let crmType = $scope.tab.organization.type;
    crmType = crmType.charAt(0).toUpperCase() + crmType.slice(1); // Capitalize
    //interpret the $crmType inside the templates
    $scope.noUserLinkedString = eval('`' + $translate.instant('crm/user-profile/no-user-linked') + '`');
    $scope.searchOnCrmString = eval('`' + $translate.instant('crm/user-profile/search-on-crm') + '`');
    $scope.createANewCrmContactString = eval('`' + $translate.instant('crm/user-profile/create-a-new-crm-contact') + '`');

    // Configure "Create contact" button
    // Does it redirect to an external form or does it open a form in Alcmeon ?
    $scope.newContactCreationMode = crmStrategy.getNewContactCreationMode(org, parseInt($scope.tab.linkedDataContext.companyId));
  }

}

function link($scope, element) {

  const searchColumn = element.find('.search-column')[0];
  const searchScrollbar = new PerfectScrollbar(searchColumn);
  const searchResultsColumn = element.find('.search-results-column')[0];
  const searchResultsScrollbar = new PerfectScrollbar(searchResultsColumn);
  $scope.$on('$destroy', () => {
    searchScrollbar.destroy();
    searchResultsScrollbar.destroy();
  });

}
